import axiosInstance from './axiosConfig';

// PFRS-for-SMEs income statement (backend/routes/incomeStatementReports.js),
// mounted separately from the legacy /general-ledger/income-statement endpoints.
const incomeStatementAPI = {
  get: async ({ startDate, endDate, accountingClientId = null, segment = 'ALL' } = {}) => {
    const response = await axiosInstance.get('/income-statement', {
      params: {
        startDate,
        endDate,
        ...(accountingClientId && { accountingClient: accountingClientId }),
        segment,
      },
    });
    return response.data;
  },

  getComparative: async ({
    startDate,
    endDate,
    compareStartDate,
    compareEndDate,
    accountingClientId = null,
    segment = 'ALL',
  } = {}) => {
    const response = await axiosInstance.get('/income-statement/comparative', {
      params: {
        startDate,
        endDate,
        compareStartDate,
        compareEndDate,
        ...(accountingClientId && { accountingClient: accountingClientId }),
        segment,
      },
    });
    return response.data;
  },

  // JWT lives in memory only (never localStorage) — a plain <a href> can't carry
  // it, so the PDF must be fetched via axios (auth header attached automatically)
  // as a blob, same pattern as invoiceAPI.exportToPDF.
  exportPdf: async ({ startDate, endDate, accountingClientId = null, segment = 'ALL' } = {}) => {
    try {
      const response = await axiosInstance.get('/income-statement/pdf', {
        params: {
          startDate,
          endDate,
          segment,
          ...(accountingClientId && { accountingClient: accountingClientId }),
        },
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      if (error.response?.data instanceof Blob && error.response.data.type === 'application/json') {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          throw json.message || 'Failed to export income statement to PDF';
        } catch (parseErr) {
          if (typeof parseErr === 'string') throw parseErr;
        }
      }
      throw error.response?.data?.message || 'Failed to export income statement to PDF';
    }
  },
};

export default incomeStatementAPI;
